import styled from 'styled-components';
import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const mobileLimit = (breakpoints) => `${breakpoints.sm - 1}px`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px;
  overflow: auto;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    margin: 10px;
    overflow: hidden;
  }
`;

export const Button = styled(ButtonLayoutComponent)`
  width: 150px;
`;

export const ErrorContainer = styled.div`
  align-self: center;
  background: #FFB6B8;
  border-radius: 5px;
  display: flex;
  margin-bottom: 20px;
  padding: 20px;
`;

export const ErrorHandlerContainer = styled.div`
  display: flex;
  padding-top: 150px;
  justify-content: center;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    margin-top: 20px;
  }
`;

export const ContainerMessage = styled.div`
  margin-left: 35px;
  color: ${({ theme }) => theme.color.textError};
  font-weight: 500;
  display: ${({ hidden }) => hidden && 'hidden'};
`;

export const Text = styled(TextLayoutComponent)`
  font-size: 14px;
  text-align: center;
`;
